import type { ACPStatus } from "@/features/acp/types";
import { Button2 } from "@/ui2/atoms/Button";
import { cn } from "@/lib/helpers/cn";
import DownloadIcon from "@/assets/images/icons2/icon--download.svg?component";
import type { PatientConsent, UUID } from "@/core/types";
import { viewPatientPolicyFile } from "@/utils/fileUtil";

type DownloadButtonProps = {
  consentStatus: ACPStatus;
  patientId: UUID;
  reportKey: PatientConsent["user_file_report_key"];
};

export function DownloadButton({ consentStatus, patientId, reportKey }: DownloadButtonProps) {
  const isDisabled = consentStatus === "OPTED_OUT" || !reportKey;

  return (
    <div className="tw:row-span-2 tw:lg:!mr-15">
      <Button2
        isDisabled={isDisabled}
        onPress={
          isDisabled
            ? undefined
            : () => viewPatientPolicyFile(patientId, reportKey, "ADVANCED_CARE_PROGRAM")
        }
        rawChildren
        title={
          isDisabled
            ? "Patient has not responded or has been opted out of the Advanced Care Program."
            : "Download Consent"
        }
        variant="blank"
      >
        <span className="tw:ml-0! tw:w-auto tw:lg2:p-1">
          <b className="tw:mr-1 tw:lg2:hidden">Download: </b>
          <DownloadIcon className={cn(isDisabled && "tw:opacity-50!")} />
        </span>
      </Button2>
    </div>
  );
}
